import { render, staticRenderFns } from "./ShopEditor.vue?vue&type=template&id=4628e868"
import script from "./ShopEditor.vue?vue&type=script&lang=js"
export * from "./ShopEditor.vue?vue&type=script&lang=js"
import style0 from "./ShopEditor.vue?vue&type=style&index=0&id=4628e868&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports